module.exports = __webpack_public_path__ + "img/MainScreen-off.8011c631.jpg";